/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ allocationAmount: NonNullable<unknown> }} Coinvestments_Tracking_Allocationamount_Declined2Inputs */

const en_coinvestments_tracking_allocationamount_declined2 = /** @type {(inputs: Coinvestments_Tracking_Allocationamount_Declined2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.allocationAmount} <0>(declined)</0>`)
};

/**
* | output |
* | --- |
* | "{allocationAmount} <0>(declined)</0>" |
*
* @param {Coinvestments_Tracking_Allocationamount_Declined2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_allocationamount_declined2 = /** @type {((inputs: Coinvestments_Tracking_Allocationamount_Declined2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Allocationamount_Declined2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_allocationamount_declined2(inputs)
});
export { coinvestments_tracking_allocationamount_declined2 as "coInvestments_tracking_allocationAmount_declined" }